<script lang="ts" module>
  import type { ChartValue } from 'libchartium';
  import { setContext, type ContextKey } from '#lib/utils/svelte-context.js';
  import { mut, type WritableSignal } from '@typek/signalhead';
  import type { Snippet } from 'svelte';

  export const CommonRulerContextKey: ContextKey<WritableSignal<ChartValue | undefined>> =
    Symbol('CommonRulerContext');
</script>

<script lang="ts">
  let { children }: { children?: Snippet } = $props();

  let commonRuler = mut<ChartValue>();
  setContext(CommonRulerContextKey, commonRuler);
</script>

{@render children?.()}
